// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"c3e35bac","910":"ec0a5c18"}[chunkId] + ".chunk.css";
};